import { render, staticRenderFns } from "./EditLayoutView.vue?vue&type=template&id=4231f1d0"
import script from "./EditLayoutView.vue?vue&type=script&lang=js"
export * from "./EditLayoutView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports